import { Component,Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../../../auth/auth.service';
import { Destinatario } from "../../../../../asistente-en-linea/models/Destinatario";
import { DestinatariosService } from '../../../destinatarios/destinatarios.service';

@Component({
  selector: 'app-delete-destinatario-dialog',
  templateUrl: './delete-destinatario-dialog.component.html',
  styleUrls: ['./delete-destinatario-dialog.component.scss']
})
export class DeleteDestinatarioDialogComponent implements OnInit {               
  ejecutando : boolean;
  finalizado : boolean;
  mensaje: string;
  error: boolean;
  menuList:string[];
  constructor(private destinatariosService: DestinatariosService,private authService: AuthService,public dialogRef: MatDialogRef<DeleteDestinatarioDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: Destinatario) {
    this.ejecutando =  false;     
    this.finalizado =  false;  
    this.error =  false;                                                       
  }

  ngOnInit() {
    this.validarVinculacion();
  }

  async validarVinculacion() {
    let resArray = [];
    this.menuList = [];
    resArray.push(await this.destinatariosService.validarVinculacion(this.data.id).toPromise().catch((err) => {
      alert(err);
    }));
    let resultadoMenus = [];
    let noErr = resArray.reduce((previous, current) => {
      resultadoMenus=current.content;
      return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
    }, true);
    if (noErr) {
      if (resultadoMenus.length > 0) {
        for (let m of resultadoMenus) {
          this.menuList.push(m.descripcion);
        }
      }
    }
  }
  cancelar(): void {
    this.dialogRef.close(false);                         
  }

  aceptar(): void {
    this.dialogRef.close(true);                        
  }

  
  deleteDestinatario() {
    this.ejecutando =  true;     
    this.finalizado =  false;  
    this.error =  false;  
    if(this.data.id) {
      this.destinatariosService.deleteDestinatario(this.data.id).subscribe((response: any) => {
        if (response && (response.statusCode == 200 ||response.statusCode ==0)) {
          this.finalizado =  true; 
        } else {
          this.mensaje = response.statusMessage;
          this.error =  true;
          this.ejecutando =  false; 
        }
      },
      error=>{
        this.mensaje = error;
        this.error =  true;
        this.ejecutando =  false; 
      })
    }
  }
}